import {API_URL} from "../../config";
import axios from "axios";
import {chatApi} from "../chat";
import api from "../index";

class AuthApi {
    async getToken() {
        try {
            let tokenData = JSON.parse(localStorage.getItem("token"))??null
            if ( tokenData) {
                return {headers: {Authorization: `${tokenData.token_type} ${tokenData.access_token}`}}
            } else {
                return null
            }
        } catch (e) {
            return console.error(e)
        }
    }


    async signIn(request) {
        let formData = new FormData();

        formData.append("username", request.username);
        formData.append("password", request.password);
        formData.append("FCMToken", request.FCMToken ?? "");
        try {
            return await axios({
                method: "post",
                url: API_URL + "/login",
                data: formData,
            }).then(response => {
                if (response.status === 200 && !response.data.error_message) {
                    let token = response.data.data.token
                    let user = response.data.data.user
                    localStorage.setItem("token", JSON.stringify(token))
                    localStorage.setItem("user", JSON.stringify(user))
                    return token;
                } else {
                    // return BaseAlert("error", "error", "Email or Password incorrect!");
                }
            })
        } catch (e) {
            return false
        }
    }
    async changePassword(request) {
        let formData = new FormData();
        let {userID,oldPassword, newPassword, confirmPassword} =request

        formData.append("oldPassword", request.oldPassword);
        formData.append("password", request.newPassword);
        formData.append("password_confirmation", request.confirmPassword);
        try {
            return await axios({
                method: "post",
                url: API_URL + `/web/user/${userID}/changePassword`,
                data: formData,
            }).then(response => {
                if (response.status === 200 && !response.data.error_message) {
                    return response.data
                } else {
                    return false
                }
            })
        } catch (e) {
            return false
        }
    }

    async signOut() {
        try {
            const response = await api.post(API_URL + "/logout");
            if (response.status !== 200) {
                console.warn('Logout API did not return 200:', response.status);
            }
        } catch (e) {
            console.error("API logout failed:", e);
            throw e;
        }
    }
    async forgetPassword(param) {
        try {
            return await axios.post(API_URL + `/forgetPassword`, param).then(response => {
                if (response.status === 200) {
                    return response.data
                } else {
                    // return BaseAlert("error", "ผิดพลาด", "พบข้อผิดพลาด")
                }
            })
        } catch (e) {
            return false
        }
    }

    me(request) {
        const {accessToken} = request;
        return new Promise((resolve, reject) => {
                try {
                    const user = JSON.parse(localStorage.getItem('user'))

                    if (!user) {
                        reject(new Error('Invalid authorization token'));
                        return;
                    }
                    // resolve({
                    //     id: user.id,
                    //     email: user.email ?? "",
                    //     name: user.firstname ?? "",
                    // });
                    resolve(user);
                } catch (err) {
                    console.error('[Auth Api]: ', err);
                    reject(new Error('Internal server error'));
                }
            });
    }


}

export const authApi = new AuthApi();
